import { render, staticRenderFns } from "./entity-comment-add.vue?vue&type=template&id=b2b7a480"
import script from "./entity-comment-add.vue?vue&type=script&lang=js"
export * from "./entity-comment-add.vue?vue&type=script&lang=js"
import style0 from "./entity-comment-add.vue?vue&type=style&index=0&id=b2b7a480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports